import { Pipe, PipeTransform } from '@angular/core';
import { Product } from 'src/app/products/models/product.model';

@Pipe({ name: 'percentageSave', standalone: true })
export class PercentageSavePipe implements PipeTransform {

  transform(product: Product): string {
    const actualSellingPrice = product?.price_list?.recommended_offers?.applicable_amount;
    const mrp = Number((product?.mrp?.toString())?.replace(/,/g, ''));
    const percentDiscount = ((mrp - actualSellingPrice) / mrp) * 100;
    return percentDiscount >= 1 ? percentDiscount.toFixed() + '% off' : '';
  }

}
